<script setup>
import { useRouter } from 'vue-router';
import { useMapGetter } from 'dashboard/composables/store.js';
import PaymentHistory from './components/PaymentHistory.vue';
import SettingsLayout from '../SettingsLayout.vue';
import ButtonV4 from 'next/button/Button.vue';

const router = useRouter();
const uiFlags = useMapGetter('accounts/getUIFlags');

const goBack = () => {
  router.push({ name: 'billing_settings_index' });
};
</script>

<template>
  <SettingsLayout
    :is-loading="uiFlags.isFetchingItem"
    :loading-message="$t('ATTRIBUTES_MGMT.LOADING')"
  >
    <template #header>
      <div class="flex flex-col gap-4">
        <ButtonV4
          faded
          slate
          sm
          icon="i-lucide-arrow-left"
          class="w-fit"
          @click="goBack"
        >
          {{ $t('AI_AGENTS.ACTIONS.BACK') }}
        </ButtonV4>
        <div>
          <h1 class="text-xl font-medium tracking-tight text-n-slate-12">
            {{ $t('BILLING.INVOICE.HISTORY_TITLE') }}
          </h1>
          <p class="text-sm text-n-slate-11 mt-1">
            {{ $t('BILLING.INVOICE.HISTORY_DESCRIPTION') }}
          </p>
        </div>
      </div>
    </template>
    <template #body>
      <section class="grid gap-4">
        <PaymentHistory />
      </section>
    </template>
  </SettingsLayout>
</template>
